import { RouteConfig } from "vue-router";
import { RGuideBrowse } from "@/modules/Guide/browse/RGuideBrowse";
import { RGuideTemplate } from "@/modules/Guide/template/RGuideTemplate";

export const REmployerGuide: RouteConfig = {
  path: "guide",
  component: () =>
    import(
      /* webpackChunkName: "employer-guide" */
      "./VEmployerGuide.vue"
    ),
  meta: {
    title: "Guide",
    icon: "book-outline",
    newIcon: "book",
  },
  children: [RGuideBrowse, RGuideTemplate],
};
